<template>
  <div>
    <AboutHelperComponents1MainPage />
  </div>
</template>

<script>

import Vue from 'vue'
import Component from 'vue-class-component'

import AboutHelperComponents1MainPage from './service-for-about-helper-components/about-helper-components-1-main-page.vue'

@Component({
  components: {
    AboutHelperComponents1MainPage
  }
})
class About1 extends Vue {
  //
}

export default About1


</script>

<style>

</style>